export default [
    {
        id: 1,
        name: 'Total ingresos',
        formula: '(evalResult = this.family_income_computed)',
        info:'Total ingresos',
    },
    {
        id: 2,
        name: 'Excedente familiar',
        formula: '(evalResult = this.family_income_computed)',
        info:'Excedente familiar',
    },
    {
        id: 3,
        name: 'Ingresos por salarios',
        formula: '(evalResult = this.family_income_computed)',
        info:'Ingresos por salarios',
    },
    {
        id: 4,
        name: 'Capacidad de pago',
        formula: '(evalResult = this.family_income_computed)',
        info:'El menor de los 3',
    },
]
